import { TextField } from '@mui/material';
import { useField } from 'formik';
import React from 'react';
import { Form, Label } from 'semantic-ui-react';

interface Props {
    placeholder: string;
    name: string;
    minRows: number;
    maxRows: number;
    label?: string;
    value?: string;
}

export default function SirTextArea(props: Props) {
    const [field, meta] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <TextField
                {...field}
                value={field.value || ''}
                {...props}
                id={field.value}
                placeholder={props.placeholder}
                multiline
                minRows={props.minRows}
                maxRows={props.maxRows}
                label={props.label}
                variant="outlined"
            />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}
